import React from "react";
import { Box, Grid, Typography, Link, IconButton, Container } from "@mui/material";
import { Facebook, Instagram, Pinterest, Twitter, YouTube, Email, Phone, LocationOn } from "@mui/icons-material";

const gold = "#C29D59";
const darkBg = "#F4F4F4";
const lightText ="#000";

const Footer = () => {
  return (
   
 <Box sx={{ backgroundColor: darkBg, color: "#fff", py: 6,px:8  }}>
      <Grid container spacing={11}>
        {/* 1️⃣ Logo & Social */}
        <Grid item xs={12} sm={6} md={4}>
          <Box sx={{ display: "flex", alignItems: "end",justifyContent:"start",mb:2 }}>
                   {/* <img
                     src="/images/interior-aee.png"
                     alt="logo"
                     style={{ height: 42, marginRight: 8 }}
                   /> */}
                   <Typography
                     variant="h4"
                     sx={{ fontWeight: "bold", color: "#000", letterSpacing: 1,mt:0,}}
                   >
                     Zenova
                   </Typography>
                 </Box>
          <Typography variant="body2" sx={{ color: lightText, mb: 2,textAlign:"start" }}>
            Discover your potential through mindful practices and  <br />expert-guided sessions.
          </Typography>
          <Box sx={{textAlign:"start"}}>
            {[Facebook, Instagram, Pinterest, Twitter, YouTube].map((Icon, i) => (
              <IconButton key={i} sx={{ color: "#000", mr: 1,textAlign:"start", "&:hover": { color: "#000" } }}>
                <Icon fontSize="small" />
              </IconButton>
            ))}
          </Box>
        </Grid>

        {/* 2️⃣ Quick Links */}
        <Grid item xs={12} sm={6} md={3}>
          <Typography variant="h6" sx={{ fontWeight: 600, mb: 2, color: "#000",textAlign:"start", }}>
            Quick Links
          </Typography>
          {["Home", "About", "Programs", "Instructors", "Contact"].map((item, i) => (
            <Link
              key={i}
              href="#"
              underline="none"
              sx={{
                display: "block",
                textAlign:"start",
                color: lightText,
                mb: 1,
               
              }}
            >
              {item}
            </Link>
          ))}
        </Grid>

        {/* 3️⃣ Services */}
        <Grid item xs={12} sm={6} md={3}>
          <Typography variant="h6" sx={{ fontWeight: 600, mb: 2, color: "#000",textAlign:"start", }}>
            Our Services
          </Typography>
          {[
            "Julia yoga",
            "Pilates yoga",
            "Ramon meditation",
            
          ].map((item, i) => (
            <Link
              key={i}
              href="#"
              underline="none"
              sx={{
                display: "block",
                 textAlign:"start",
                color: lightText,
                mb: 1,
               
              }}
            >
              {item}
            </Link>
          ))}
        </Grid>

        {/* 4️⃣ Useful Links */}
        <Grid item xs={12} sm={6} md={3}>
          <Typography variant="h6" sx={{ fontWeight: 600, mb: 2, color: "#000",textAlign:"start", }}>
            Useful Links
          </Typography>
          {["FAQs", "Privacy Policy", "Terms & Conditions", "Support"].map((item, i) => (
            <Link
              key={i}
              href="#"
              underline="none"
              sx={{
                display: "block",
                 textAlign:"start",
                color: lightText,
                mb: 1,
                
              }}
            >
              {item}
            </Link>
          ))}
        </Grid>

        {/* 5️⃣ Contact */}
        <Grid item xs={12} sm={6} md={3}>
          <Typography variant="h6" sx={{ fontWeight: 600, mb: 2, color: "#000",textAlign:"start", }}>
            Contact Us
          </Typography>

          <Box sx={{ display: "flex", alignItems: "start", mb: 1 }}>
            <Email sx={{ fontSize: 20, color: "#000", mr: 1 }} />
            <Typography variant="body2" sx={{ color: lightText }}>
              info@zenova.com
            </Typography>
          </Box>

          <Box sx={{ display: "flex", alignItems: "start", mb: 1 }}>
            <Phone sx={{ fontSize: 20, color: "#000", mr: 1 }} />
            <Typography variant="body2" sx={{ color: lightText }}>
              +91 98765 43610
            </Typography>
          </Box>

          <Box sx={{ display: "flex", alignItems: "start" }}>
            <LocationOn sx={{ fontSize: 20, color: "#000", mr: 1 }} />
            <Typography variant="body2" sx={{ color: lightText,textAlign:"start" }}>
              23, Green Avenue, Indiranagar,
              <br /> Bengaluru, India
            </Typography>
          </Box>
        </Grid>
      </Grid>

      {/* Bottom Line */}
      <Box
        sx={{
          borderTop: "1px solid rgba(255,255,255,0.1)",
          mt: 5,
          pt: 3,
          textAlign: "center",
        }}
      >
        <Typography variant="body2" sx={{ color: lightText }}>
          © {new Date().getFullYear()} Zenova. All rights reserved.
        </Typography>
      </Box>
    </Box>
   
   
  );
};

export default Footer;
